// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/images.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.assets.v1.SrcSet
 */
export interface SrcSet {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.Candidate candidates = 1;
     */
    candidates: Candidate[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.Candidate
 */
export interface Candidate {
    /**
     * @generated from protobuf field: string src = 1;
     */
    src: string;
    /**
     * @generated from protobuf field: uint32 width = 2;
     */
    width: number;
    /**
     * @generated from protobuf field: c1.api.assets.v1.ImageMimeType mime_type = 3;
     */
    mimeType: ImageMimeType;
}
/**
 * @generated from protobuf enum c1.api.assets.v1.ImageMimeType
 */
export enum ImageMimeType {
    /**
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * image/png
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_PNG = 1;
     */
    PNG = 1,
    /**
     * image/webp
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_WEBP = 2;
     */
    WEBP = 2,
    /**
     * image/jpeg
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_JPEG = 3;
     */
    JPEG = 3,
    /**
     * image/svg+xml
     *
     * @generated from protobuf enum value: IMAGE_MIME_TYPE_SVG = 4;
     */
    SVG = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class SrcSet$Type extends MessageType<SrcSet> {
    constructor() {
        super("c1.api.assets.v1.SrcSet", [
            { no: 1, name: "candidates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Candidate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.SrcSet
 */
export const SrcSet = new SrcSet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Candidate$Type extends MessageType<Candidate> {
    constructor() {
        super("c1.api.assets.v1.Candidate", [
            { no: 1, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "width", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "mime_type", kind: "enum", T: () => ["c1.api.assets.v1.ImageMimeType", ImageMimeType, "IMAGE_MIME_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.Candidate
 */
export const Candidate = new Candidate$Type();
